import React, { FunctionComponent } from 'react'
import { Link } from 'gatsby'
import { sanitizeHtml } from '../../../lib/sanitizeHtml'

interface VideoStripProps {
  title: string
  duration: string
  thumbnail?: string
  tag?: string
  url: string
  maxTitleLength?: number
}

const MAX_TITLE_LENGTH = 100

export const VideoStrip: FunctionComponent<VideoStripProps> = ({
  title: ogTitle,
  duration,
  thumbnail,
  tag,
  url,
  maxTitleLength = MAX_TITLE_LENGTH,
}) => {
  const imgSrc =
    thumbnail ||
    'https://www.paypalobjects.com/docsvideoassets/video-thumbnail2.svg'

  const title =
    ogTitle?.length > maxTitleLength
      ? `${ogTitle.slice(0, maxTitleLength)}...`
      : ogTitle

  return (
    <a href={url} className="videoStrip-link">
      <div className="videoStrip-wrapper">
        <img src={imgSrc} alt={ogTitle} className="videoStrip-thumbnail" />

        <div className="videoStrip-text">
          <h1
            className="videoStrip-title"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}
          />
          <div className="videoStrip-caption">
            {tag && <div className="videoStrip-button"> {tag} </div>}
            <p className="videoStrip-duration">{duration}</p>
          </div>
        </div>
      </div>
    </a>
  )
}
